import K from "./constants";
import restHelpers from "../helpers/restHelper";

const installationsCheck = (user_id, imei) => {
  const url = K.API_URL + `/api/v2/agreements/installationcheck/${user_id}/${imei}`;
  return restHelpers.withBearer.get(url, {});
};

const subscriptions = (user_id, imei) => {
  const url = K.API_URL + `/api/v2/agreements/subscription/${user_id}/${imei}`;
  return restHelpers.withBearer.get(url, {});
};

const deleteAgreement = (type, filename) => {
  const url = K.API_URL + `/api/v2/agreements/${type}/${filename}`;
  return restHelpers.withBearer.delete(url, {});
};

const download = (type, filename) => {
  const url = K.API_URL + `/api/v2/agreements/${type}/${filename}`;
  return restHelpers.withBearer.get(url, {});
};

export default {
  installationsCheck,
  subscriptions,
  delete: deleteAgreement,
  download
};



// WEBPACK FOOTER //
// ./src/services/agreements.js